import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './../less/addiction-theme.css';
import HeaderContainer from './HeaderContainer';
import BodyContainer from './BodyContainer';
import SidePanelContainer from './SidePanelContainer';
import { Route } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar'
import 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import {postLocation, togglePanel} from "../redux/actions";
import {isMobile} from 'react-device-detect';

class App extends Component {
    constructor(props) {
        super(props);


        this.props.history.listen((location, action) => {
            this.props.sendLocation(location.pathname)
        });
        this.state = { width: window.innerWidth, height: window.innerHeight };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
        if (this.state.width < 799 && this.props.panel.leftPanelOpen === true) {
            this.props.toggleLeft();
        }
        if (this.state.width < 799 && this.props.panel.rightPanelOpen === true) {
            this.props.toggleRight();
        }
        if (this.state.width > 799 && this.props.panel.leftPanelOpen === false ) {
            this.props.toggleLeft();
        }
        if (this.state.width > 799 && this.props.panel.rightPanelOpen === false) {
            this.props.toggleRight();
        }
    }


    render() {
        // if (this.state.width < 1200) return <div className="text-center">This website requires a larger resolution to display properly.  Please enlarge or maximize your window.</div>;
        // if (isMobile) return <div className="text-center"> Mobile is not supported. Please use a desktop browser.</div>;
        return this.props.init ?
        (
            <div>
                <LoadingBar showFastActions className="loading-bar" />
                <Route path="/" component={HeaderContainer} />
                <SidePanelContainer />
                <Route path="/" component={BodyContainer} />
            </div>
        ) : (<div className="text-center"><FontAwesomeIcon className="text-primary" size="6x" icon={faSpinner} spin fixedWidth /></div>);
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        init: state.init,
        panel: state.panel,
    };
};

const mapDispatchToProps = (dispatch) => ({
    toggleLeft: () => dispatch(togglePanel('left')),
    toggleRight: () => dispatch(togglePanel('right')),
    sendLocation: (location) => dispatch(postLocation(location)),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));


// WEBPACK FOOTER //
// ./src/App/App.js